function Aboutus() {
  return (
    <>
      {/* Page Title */}
      <div className="page-title" data-aos="fade">
        <div className="container">
          <nav className="breadcrumbs">
            <ol>
              <li><a href="index.html">Home</a></li>
              <li className="current">About Us</li>
            </ol>
          </nav>
          <h1>About Us</h1>
        </div>
      </div>

      {/* About Section */}
      <section id="about" className="about section">
        <div className="container">
          <h2>About CA Sanjay Prasad & Associates</h2>
          <p>
            <strong>CA Sanjay Prasad & Associates</strong> is a leading chartered accountancy firm
            committed to providing expert financial, taxation, audit, and business advisory services.
            With years of experience serving <strong>individuals, startups, small & medium businesses, and corporates</strong>, 
            we combine technical expertise with a personalized approach to deliver practical and reliable solutions.
          </p>

          <h2>Our Expertise</h2>
          <p>
            Our team specializes in a wide range of services including <strong>income tax planning and filing, GST compliance, statutory and internal audits, bookkeeping, accounting, payroll management, and corporate advisory</strong>. 
            We ensure compliance with all regulatory requirements while helping clients optimize their financial and operational performance.
          </p>

          <h2>Why Choose Us?</h2>
          <p>
            Clients choose <strong>CA Sanjay Prasad & Associates</strong> because we focus on building long-term relationships through trust, transparency, and professional excellence. 
            Our key differentiators include:
          </p>

          <ul>
            <li><strong>Personalized Approach:</strong> We understand each client’s unique needs and offer customized solutions.</li>
            <li><strong>Expertise:</strong> Led by CA Sanjay Prasad, our team brings deep knowledge of taxation, auditing, and business advisory.</li>
            <li><strong>Integrity:</strong> We adhere to ethical practices in all financial and advisory services.</li>
            <li><strong>Timely Support:</strong> We provide proactive advice and responsive service to keep clients compliant and confident.</li>
            <li><strong>Business Growth Focus:</strong> Beyond compliance, we help clients make informed decisions to achieve sustainable growth.</li>
          </ul>

          <h2>Our Clientele</h2>
          <p>
            We proudly serve a diverse range of clients including <strong>individuals, professionals, startups, entrepreneurs, SMEs, and large corporates</strong>. 
            Our tailored solutions ensure financial clarity, regulatory compliance, and strategic business guidance for every client.
          </p>
        </div>
      </section>
    </>
  );
}

export default Aboutus;
